import React from 'react'
import { Button, Grid, Typography, Container, IconButton, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import { Logout, DarkMode, LightMode } from '@mui/icons-material'
import useAppStore from '../hooks/useAppStore'

interface HeaderProps {
  handleLogout: () => void
  userName: string
  toggleTheme?: () => void
  isDarkMode?: boolean
}

const Header: React.FC<HeaderProps> = ({ handleLogout, userName, toggleTheme, isDarkMode }): React.ReactElement => {
  const { logoUrl } = useAppStore() as { logoUrl: string }
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))
  
  return (
    <Container
      maxWidth={false}
      sx={{
        boxShadow: 3,
        display: 'flex',
        justifyContent: 'center'
      }}>
      <Grid 
        container 
        maxWidth={'xl'} 
        padding={{ xs: 2, sm: 2.5, md: 3 }}
        spacing={{ xs: 1, sm: 2 }}
      >
        <Grid 
          item 
          container 
          xs={12} 
          sm={5}
          md={6} 
          lg={6}
          sx={{ alignItems: 'center', gap: { xs: '0.5rem', md: '1rem' }}}
        >
          <img 
            src={logoUrl} 
            alt="Brand Logo"
            className='logo' 
            style={{ maxWidth: isMobile ? '150px' : isTablet ? '200px' : '250px' }}
          />
        </Grid>
        <Grid 
          item 
          container 
          spacing={1} 
          xs={12} 
          sm={7}
          md={6} 
          lg={6}
          justifyContent={{ xs: 'center', sm: 'flex-end' }}
          alignItems="center"
        >
          <Typography 
            variant="body2" 
            sx={{ 
              display: { xs: 'none', sm: 'block' },
              width: '100%',
              textAlign: 'right',
              mb: 0.5
            }}
          >
            Eingeloggt als {userName}
          </Typography>
          <Grid 
            container 
            item 
            gap={{ xs: 1, sm: 1.5, md: 2 }} 
            justifyContent={{ xs: 'center', sm: 'flex-end' }} 
            alignItems={'center'}
            wrap="nowrap"
          >
            {toggleTheme && (
              <Tooltip title={isDarkMode ? 'Hell-Modus aktivieren' : 'Dunkel-Modus aktivieren'}>
                <IconButton onClick={toggleTheme} color="primary" size={isMobile ? 'small' : 'medium'}>
                  {isDarkMode ? <LightMode /> : <DarkMode />}
                </IconButton>
              </Tooltip>
            )}
            <Button
              variant="text"
              size={isMobile ? 'small' : 'medium'}
              onClick={() => window.location.href = "/profile"}
            >
              {isMobile ? 'Profil' : 'Mein Profil'}
            </Button>
            <Button 
              variant="outlined" 
              size={isMobile ? 'small' : 'medium'}
              endIcon={!isMobile && <Logout />} 
              onClick={handleLogout}
            >
              {isMobile ? <Logout /> : 'Logout'}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}

export default Header
